import { render } from 'react-dom'
import React, { useState, useCallback, useEffect } from 'react'
import { useTransition, animated } from '@react-spring/web'
//import './styles.css'
import {
  useAudioStore,
  useSceneStore,
} from '../store'
import SlideStatus from './SlideStatus'
import AnimatedBookDescription from './AnimatedBookDescription'


const OtherAfter = ({setHover}) => {
  return (
    <>
      <h2 className="mobile-title">After: A Survivor's Story</h2>
      <SlideStatus phrases={[
        <>Read the <a href="https://www.kirkusreviews.com/book-reviews/hallee-adelman/after-9/" target="_blank" rel="noreferrer">Kirkus Starred Review</a></>,
        <>Bank Street College of Education, <a href="https://educate.bankstreet.edu/cgi/viewcontent.cgi?article=1036&context=cbc_awards" target="_blank" rel="noreferrer">Best Children's Books of the Year 2026</a></>,
   
        'Available in Hardcover',
           ]} />
      <p>
      Moving forward after a traumatic event isn’t easy, but finding community can help. After living through The Horrible Day, a young girl struggles to get the fear off her skin. Why is she still here when her friend Wes isn’t? Adults try to comfort her, but they don’t understand; they weren’t there. Other people have survived their own Horrible Days, though, and by joining together to speak up, they can give each other the strength they all need to move on. In this book, author Hallee Adelman looks at one of the toughest subjects of our time through the eyes of a young person whose life has been forever changed by gun violence. 
           
      </p>
      <div className="all-links">
        <div className="store-links">
          <h4 className="preorder">Order Now!</h4>
          <div className="buylink-group" id="buylinks"
          onMouseEnter={() => setHover(false)} 
          onMouseLeave={() => setHover(true)} >
            <ul>
              <li className="buylink">
                <a className="link" href="https://www.amazon.com/After-Survivors-Story-Hallee-Adelman/dp/0807530956" target="_blank">
                  <img
                    src="https://halleeadelman.wohpro.com/wp-content/uploads/sites/3/2019/12/amazon.png"
                    alt="Amazon"
                  />
                </a>
              </li>
              <li className="buylink">
                <a className="link" href="https://www.barnesandnoble.com/w/after-hallee-adelman/1147107409" target="_blank">
                  <img
                    src="https://halleeadelman.wohpro.com/wp-content/uploads/sites/3/2019/12/bn.png"
                    alt="Barnes &amp; Noble"
                  />
                </a>
              </li>
              <li className="buylink">
                <a className="link" href="https://bookshop.org/p/books/after-a-survivor-s-story-hallee-adelman/5165a6038119e07d?ean=9780807530955&bkshp-astro=t" target="_blank">
                  <img
                    src="https://halleeadelman.wohpro.com/wp-content/uploads/sites/3/2023/03/bookshop.jpg" 
                    alt="Bookshop"
                  />
                </a>
              </li>
              <li className="buylink">
                <a className="link" href="https://www.booksamillion.com/p/After/Hallee-Adelman/9780807530955" target="_blank">
                  <img
                    src="https://halleeadelman.wohpro.com/wp-content/uploads/sites/3/2019/12/bam.png"
                    alt="Books-A-Million"
                  />
                </a>
              </li>
              
              
              <li className="buylink">
                <a className="link" href="https://bookshop.org/p/books/after-a-survivor-s-story-hallee-adelman/22447758?ean=9780807530955&next=t&next=t" target="_blank">
                  <img
                    src="https://halleeadelman.wohpro.com/wp-content/uploads/sites/3/2019/12/cbw.png"
                    alt="Children's Book World"
                  />
                </a>
              </li>
      {
              <li className="buylink">
                <a className="link" href="https://www.albertwhitman.com/book/after/" target="_blank">
                  <img
                    src="https://halleeadelman.wohpro.com/wp-content/uploads/sites/3/2019/12/albertwhitman96.png"
                    alt="Albert Whitman"
                  />
                </a>
              </li>
       /*
              <li className="buylink">
                <a className="link" href="https://www.target.com/p/the-strongest-thing-by-hallee-adelman-hardcover/-/A-85332467#lnk=sametab" target="_blank">
                  <img
                    src="https://halleeadelman.wohpro.com/wp-content/uploads/sites/3/2019/12/target.png"
                    alt="Target"
                  />
                </a>
              </li>
              */}
            </ul>
          </div>
        </div>
      </div>
     
    </>
  )
}


const OtherStrongest = ({setHover}) => {
  return (
    <>
      <h2 className="mobile-title">The Strongest Thing</h2>
      <SlideStatus phrases={[
        <a href="https://store.momschoiceawards.com/product/12122" target="_blank" rel="noreferrer">2022 Mom's Choice Award - Gold Recipient</a>,
        'Available in Hardcover',
      ]} />
      <p>
      Sera doesn’t always like being at home, where her dad’s anger feels like the strongest thing. School feels better. But when Sera gets into an argument with a friend and finds herself acting like the bully at home, she discovers that the strongest thing isn’t loud or angry at all.
      </p>
      <div className="all-links">
        <div className="store-links">
          <h4 className="preorder">Order Now!</h4>
          <div className="buylink-group" id="buylinks"
          onMouseEnter={() => setHover(false)} 
          onMouseLeave={() => setHover(true)} >
            <ul>
              <li className="buylink">
                <a className="link" href="https://www.amazon.com/Strongest-Thing-When-Home-Feels/dp/0807531685/ref=sr_1_1?dchild=1&keywords=9780807531686&qid=1632416213&sr=8-1" target="_blank">
                  <img
                    src="https://halleeadelman.wohpro.com/wp-content/uploads/sites/3/2019/12/amazon.png"
                    alt="Amazon"
                  />
                </a>
              </li>
              <li className="buylink">
                <a className="link" href="https://www.barnesandnoble.com/w/the-strongest-thing-hallee-adelman/1140014475?ean=9780807531686" target="_blank">
                  <img
                    src="https://halleeadelman.wohpro.com/wp-content/uploads/sites/3/2019/12/bn.png"
                    alt="Barnes &amp; Noble"
                  />
                </a>
              </li>
              <li className="buylink">
                <a className="link" href="https://bookshop.org/p/books/the-strongest-thing-when-home-feels-hard-hallee-adelman/e38fe44336bad723?ean=9780807531686&bkshp-astro=t" target="_blank">
                  <img
                    src="https://halleeadelman.wohpro.com/wp-content/uploads/sites/3/2023/03/bookshop.jpg" 
                    alt="Bookshop"
                  />
                </a>
              </li>
              <li className="buylink">
                <a className="link" href="https://www.booksamillion.com/p/Strongest-Thing/Hallee-Adelman/9780807531686?id=8306084943085" target="_blank">
                  <img
                    src="https://halleeadelman.wohpro.com/wp-content/uploads/sites/3/2019/12/bam.png"
                    alt="Books-A-Million"
                  />
                </a>
              </li>
              
              
              <li className="buylink">
                <a className="link" href="https://childrensbookworld.net/adelman-assorted-titles/" target="_blank">
                  <img
                    src="https://halleeadelman.wohpro.com/wp-content/uploads/sites/3/2019/12/cbw.png"
                    alt="Children's Book World"
                  />
                </a>
              </li>
      
              <li className="buylink">
                <a className="link" href="https://www.albertwhitman.com/book/the-strongest-thing/" target="_blank">
                  <img
                    src="https://halleeadelman.wohpro.com/wp-content/uploads/sites/3/2019/12/albertwhitman96.png"
                    alt="Albert Whitman"
                  />
                </a>
              </li>
       {/*
              <li className="buylink">
                <a className="link" href="https://www.target.com/p/the-strongest-thing-by-hallee-adelman-hardcover/-/A-85332467#lnk=sametab" target="_blank">
                  <img
                    src="https://halleeadelman.wohpro.com/wp-content/uploads/sites/3/2019/12/target.png"
                    alt="Target"
                  />
                </a>
              </li>
              */}
            </ul>
          </div>
        </div>
      </div>
    </>
  )
}

const OtherQuietship = ({setHover}) => {
  return (
    <>
      <h2 className="mobile-title">My Quiet Ship</h2>
      <SlideStatus phrases={[
        <>2019 SCBWI <a href="https://en.wikipedia.org/wiki/Crystal_Kite_Award" target="_blank" rel="noreferrer">Crystal Kite Award</a> Finalist.</>,
        'Available in Hardcover & Paperback',
        
      ]} />
      <p>
      Whenever the yelling in his house starts, Quinn uses his imagination to become Commander of the Quiet Ship. There he pretends to travel far, far away from the yelling sounds. A thoughtful treatment of a difficult topic, this story is for children or families whose home is sometimes filled with sounds that they’d like to quiet down. </p>
      
      <div className="all-links">
        <div className="store-links">
          <h4 className="preorder">Order Now!</h4>
          <div className="buylink-group" id="buylinks"
          onMouseEnter={() => setHover(false)} 
          onMouseLeave={() => setHover(true)} >
            <ul>
              <li className="buylink">
                <a className="link" href="https://www.amazon.com/My-Quiet-Ship-Hallee-Adelman/dp/0807567132" target="_blank">
                  <img
                    src="https://halleeadelman.wohpro.com/wp-content/uploads/sites/3/2019/12/amazon.png"
                    alt="Amazon"
                  />
                </a>
              </li>
              <li className="buylink">
                <a className="link" href="https://www.barnesandnoble.com/w/my-quiet-ship-hallee-adelman/1138629533?ean=9780807567142" target="_blank">
                  <img
                    src="https://halleeadelman.wohpro.com/wp-content/uploads/sites/3/2019/12/bn.png"
                    alt="Barnes &amp; Noble"
                  />
                </a>
              </li>
              <li className="buylink">
                <a className="link" href="https://bookshop.org/p/books/my-quiet-ship-when-they-argue-hallee-adelman/eacbedf4dfc5df1e?ean=9780807567166&bkshp-astro=t" target="_blank">
                  <img
                    src="https://halleeadelman.wohpro.com/wp-content/uploads/sites/3/2023/03/bookshop.jpg" 
                    alt="Bookshop"
                  />
                </a>
              </li>
              <li className="buylink">
                <a className="link" href="https://www.booksamillion.com/p/My-Quiet-Ship/Hallee-Adelman/9780807567135?id=7327036160373" target="_blank">
                  <img
                    src="https://halleeadelman.wohpro.com/wp-content/uploads/sites/3/2019/12/bam.png"
                    alt="Books-A-Million"
                  />
                </a>
              </li>
            
          
              <li className="buylink">
                <a className="link" href="https://childrensbookworld.net/adelman-assorted-titles/" target="_blank">
                  <img
                    src="https://halleeadelman.wohpro.com/wp-content/uploads/sites/3/2019/12/cbw.png"
                    alt="Children's Book World"
                  />
                </a>
              </li>
           
              <li className="buylink">
                <a className="link" href="https://www.albertwhitman.com/book/my-quiet-ship/" target="_blank">
                  <img
                    src="https://halleeadelman.wohpro.com/wp-content/uploads/sites/3/2019/12/albertwhitman96.png"
                    alt="Albert Whitman"
                  />
                </a>
              </li>
           
              {/*
               <li className="buylink">
                <a className="link" href="https://www.target.com/p/my-quiet-ship-by-hallee-adelman/-/A-84817800?preselect=84275768#lnk=sametab" target="_blank">
                  <img
                    src="https://halleeadelman.wohpro.com/wp-content/uploads/sites/3/2019/12/target.png"
                    alt="Target"
                  />
                </a>
              </li>
              */}
            </ul>
           
          </div>
          
        </div>
        
      </div>
      <div
        className="more-links"
        onMouseEnter={() => setHover(false)}
        onMouseLeave={() => setHover(true)}
      >
        <a href="https://myquietship.com" target="_blank" rel="noreferrer">
          <button type="button">See More at MyQuietShip.com</button>
        </a>
      </div>
     
    </>
  )
}

const pages = [
  ({ style, setHover }) => <animated.div style={{ ...style}}><OtherAfter setHover={setHover}/></animated.div>,
  ({ style, setHover }) => <animated.div style={{ ...style}}><OtherStrongest setHover={setHover}/></animated.div>,
  ({ style, setHover }) => <animated.div style={{ ...style}}><OtherQuietship setHover={setHover}/></animated.div>,
]

/*
const pages = {
        WPWorried,
        WPMad,
       // WPSad,
       // WPJealous,
      }
*/
function SlidesOther() {

  const { cursorActive, bookOtherIndex  } = useSceneStore(state => state)
  const { setCursorActive, setBookOtherIndex } = useSceneStore(state => state.actions)
  
  
  // bookOtherIndex is 0..2 while browsing, and 3 when the stack resets.
  // pages only has 0..2, so map before the first render — useState(bookOtherIndex)
  // crashes on remount (navigating back home) when the stored index is 3.
  const toPageIndex = (bookIndex) => {
    const count = pages.length
    if (typeof bookIndex !== 'number' || bookIndex < 0 || bookIndex >= count) return 0
    return (count - bookIndex) % count
  }

  const [index, set] = useState(() => toPageIndex(bookOtherIndex))

  const panels = new Array(2)
  const onClick = useCallback(() => set((state) => (state + 1) % 6), [])
 // const transitions = useTransition(index, (p) => p, {
 // const transitions = useTransition(pages[bookIndex], {
  const transitions = useTransition(index, {
    keys: index+'other',
    from: { opacity: 0.5 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
    exitBeforeEnter: true
  })


  useEffect(() => {
   // console.log('slides: index:'+index+' , bookindex:'+bookIndex)
    set(toPageIndex(bookOtherIndex))
   }, [bookOtherIndex])

 

   function setHover(boo){
    // console.log('boo is '+boo)
      setCursorActive(boo);
   }


  return (
    <AnimatedBookDescription className="book-description lefty">
      
       {transitions((styles, i) => {
       const Page = pages[i]
        if (typeof Page !== 'function') return null
        return <Page key={i+'pg'} style={styles} setHover={(e) => setHover(e)} />
     }
     
     )}
    
    </AnimatedBookDescription>
  )
}

export default SlidesOther